import EmptyMessage from '../../components/emptyMessage/EmptyMessage';

const Unauthorized = () => {
  return (
    <div className='page-container py-5'>
      <EmptyMessage show message="You don't have permission to this action" />
    </div>
  );
};

export default Unauthorized;
